import { request } from '@/utils/request'
const QueryService = {
  state: {},

  mutations: {},

  actions: {
    YongNengFenXiForYongNengChaXunSearch({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/YongNengFenXiForYongNengChaXunSearch', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    YongNengFenXiForYongNengChaXunSearchDayList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/YongNengFenXiForYongNengChaXunSearchDayList', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    YongNengFenXiForFengGuFenXiSearch({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/YongNengFenXiForFengGuFenXiSearch', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetDianNengXaoHaoForPieChart({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v1/GetDianNengXaoHaoForPieChart', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetDianNengXiaoHaoForBarChart({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v1/GetDianNengXiaoHaoForBarChart', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetSankeyDataSource({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v1/GetSankeyDataSource', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default QueryService
